import { useEffect } from "react";
import { Form } from "react-bootstrap";

export function WeekSelector(props) {
    useEffect(() => {
        if (props.weeks && !props.week) {
            for (const w of props.weeks) {
                if (Date.now() < (Date.parse(w.open) + 7 * 24 * 60 * 60 * 1000)) {
                    props.setWeek(w);
                    return;
                }
            }
            if (!props.week) {
                props.setWeek(props.weeks[props.weeks.length -1])
            }
        }
    }, [props]);

    const findWeek = (number, weeks) => {
        if (!weeks) {
            return null;
        }
        return weeks.filter((w) => { return w.number === number; })[0];
    }

    if (!props.weeks || props.weeks.length === 0 || !props.week) {
        return (<></>);
    }

    return (
        <Form.Select className="w-auto" id={props.id} onChange={(e) => props.setWeek(findWeek(parseInt(e.target.value), props.weeks))} value={props.week.number}>
            {props.weeks.filter((w, i) => {
                if (i === 0) {
                    return true;
                }
                if (props.noFutureWeeks) {
                    return (Date.parse(w.open) - 24 * 60 * 60 * 1000) < Date.now();
                }
                return true;
            }).map((w) => {
                return <option key={w.number} value={w.number}>Week {w.number}</option>
            })}
        </Form.Select>
    );
};